import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import conversion from "../../assets/wito.png";
import backImage from "../../assets/fondo.png";
import FieldIcon from "../../utils/Register/field_icon";
import SendBtn from "../../utils/Register/send_btn";
import { useNavigate } from "react-router-dom";
import { FaQuestionCircle } from "react-icons/fa";
import { jwtDecode } from "jwt-decode";

const OrganizationProfile = () => {
  const navigate = useNavigate();
  const [organization, setOrganization] = useState("");
  const [identification, setIdentification] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [error, setError] = useState("");
  const token = useSelector((state) => state.user.token);
  const [userId, setUserId] = useState("");

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!organization || !identification || !phone || !city) {
      setError("Por favor, complete todos los campos.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/organizations`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: organization,
            identification,
            phone,
            city,
            user_id: userId,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }
      navigate("/organization-profile-img");
    } catch (error) {
      setError(error.message);
      console.error("Error al crear la organización:", error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen my-8">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        {/* Encabezado */}
        <div className="text-center text-white mb-8 mt-12">
          <h1 className="text-5xl font-bold">Datos</h1>
          <p className="text-lg mt-2">De tu organización</p>
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        {/* Formulario */}
        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <h2 className="text-2xl font-bold text-center mb-6">
            Ingresa a tu cuenta
          </h2>
          <form onSubmit={handleSubmit}>
            {/* Campo de organización */}
            <FieldIcon
              id="orgnization"
              name="orgnization"
              type="text"
              autoComplete="orgnization"
              placeholder="Nombre de tu organización"
              value={organization}
              required
              label="Nombre de la organización"
              onChange={(e) => setOrganization(e.target.value)}
            />
            {/* Campo de cédula */}
            <FieldIcon
              id="identification"
              name="identification"
              type="text"
              autoComplete="identification"
              placeholder="Introduce tu cédula"
              value={identification}
              required
              label="CI"
              icon={<FaQuestionCircle />}
              tooltip="Manejarás informacisón personal"
              onChange={(e) => setIdentification(e.target.value)}
            />
            {/* Campo de teléfono */}
            <FieldIcon
              id="phone"
              name="phone"
              type="tel"
              autoComplete="phone"
              placeholder="Introduce tu teléfono"
              value={phone}
              required
              label="Número de teléfono"
              onChange={(e) => setPhone(e.target.value)}
            />
            <FieldIcon
              id="city"
              name="city"
              type="text"
              autoComplete="city"
              placeholder="Introduce tu teléfono"
              value={city}
              required
              label="Introduce tu ciudad"
              onChange={(e) => setCity(e.target.value)}
            />

            {/* Botón de entrada */}
            <SendBtn
              label="Entrar"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
            {error && <p className="text-red-500">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default OrganizationProfile;
